'use client';

export { AnimatedBattleList } from './AnimatedBattleList';
